/* TerraLife — mesure d'usage de la boutique, anonyme, pour les visiteurs qui ont accepté les
   statistiques (cookie tl_consent, assets/terralife-consent.js). Envoyée à l'admin-app
   (fonction « track », table site_events) : par page vue, l'arrivée et sa provenance, le temps
   passé (onglet visible) et le défilement maximal ; et la provenance distingue la pub Google, Google Shopping gratuit, la pub Meta et les assistants IA ; les clics de menu, les recherches (et
   leur nombre de résultats), les filtres, l'option étiquette, la lecture de la description,
   les clics vers les guides, les ajouts au panier et aux favoris, les cartes produits vues et cliquées. Pas de cookie : un identifiant aléatoire par visite (sessionStorage),
   ni adresse IP, ni donnée personnelle. Le type de page vient de window.tlPage (layout). */
(() => {
  // Only the published theme is measured: the team's previews of other themes don't count.
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return;
  if (window.Shopify && window.Shopify.designMode) return;

  const ENDPOINT = 'https://benlfmuayvbsukzlcssm.supabase.co/functions/v1/track';
  const page = window.tlPage || { type: 'other' };

  const allowed = () => /(?:^|;\s*)tl_consent=(?:granted|a1)/.test(document.cookie);

  let store = null;
  try {
    store = window.sessionStorage;
  } catch (e) {}

  const newId = () =>
    window.crypto && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

  let session = store && store.getItem('tl_sid');
  const landing = !session;
  if (!session) {
    session = newId();
    try {
      store && store.setItem('tl_sid', session);
    } catch (e) {}
  }

  const device = () => {
    const w = window.innerWidth;
    return w < 768 ? 'mobile' : w < 1025 ? 'tablet' : 'desktop';
  };

  /** Where the visit comes from (only for its first page). */
  const source = () => {
    const q = new URLSearchParams(location.search);
    const medium = (q.get('utm_medium') || '').toLowerCase();
    const utm = (q.get('utm_source') || '').toLowerCase();
    let host = '';
    try {
      host = document.referrer ? new URL(document.referrer).hostname : '';
    } catch (e) {}
    // Same rules as the admin's Publicité screen (src/lib/ad-channels.ts).
    const paid = /cpc|ppc|paid|ads?$|retargeting|display/.test(medium);
    if (q.has('gclid') || q.has('gbraid') || q.has('wbraid') || (paid && /google/.test(utm))) return 'google_ads';
    if (paid && (/^(facebook|fb|instagram|ig|meta|an|messenger|threads)$/.test(utm) || /facebook\.|instagram\./.test(host))) return 'meta_ads';
    if (paid && /openai|chatgpt/.test(utm)) return 'openai_ads';
    if (paid) return 'ads';
    // AI assistants (ChatGPT tags its links utm_source=chatgpt.com), before Google: gemini.google.com.
    if (/chatgpt|openai|perplexity|claude|gemini|copilot|mistral|deepseek/.test(utm) ||
      /(^|\.)(chatgpt\.com|chat\.openai\.com|perplexity\.ai|claude\.ai|gemini\.google\.com|copilot\.microsoft\.com|chat\.mistral\.ai|chat\.deepseek\.com)$/.test(host)) return 'ai';
    // srsltid: Merchant Center tags every Google link (organic results included), not only free listings.
    if (q.has('srsltid')) return 'google';
    if (medium === 'email' || /klaviyo|newsletter|mail/.test(utm)) return 'email';
    if (!host) return utm ? 'other' : 'direct';
    if (/(^|\.)google\./.test(host)) return 'google';
    if (/bing\.|duckduckgo\.|qwant\.|ecosia\.|yahoo\.|brave\./.test(host)) return 'search_other';
    if (/facebook\.|instagram\.|tiktok\.|pinterest\.|youtube\.|t\.co$|threads\./.test(host)) return 'social';
    if (/shop\.app$/.test(host)) return 'shop';
    if (/mail|klaviyo/.test(host)) return 'email';
    return 'other';
  };

  const queue = [];
  const push = (e) => {
    if (!allowed()) return;
    queue.push({ t: page.type, p: location.pathname, ...e });
  };

  const send = (all) => {
    if (!all.length || !allowed()) return;
    // The endpoint takes at most 60 events per call (cards seen can be many).
    for (let i = 0; i < all.length; i += 50) sendBatch(all.slice(i, i + 50));
  };
  const sendBatch = (events) => {
    const body = JSON.stringify({ s: session, d: device(), events });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  };

  // ---------- Time on page (visible tab) and deepest scroll ----------
  let visibleSince = document.visibilityState === 'visible' ? performance.now() : null;
  let engaged = 0;
  let maxScroll = 0;
  const measureScroll = () => {
    const doc = document.documentElement;
    const height = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    const seen = window.scrollY + window.innerHeight;
    const pct = height > 0 ? Math.min(100, Math.round((seen / height) * 100)) : 100;
    if (pct > maxScroll) maxScroll = pct;
  };
  window.addEventListener('scroll', measureScroll, { passive: true });
  window.addEventListener('load', measureScroll);
  measureScroll();

  let pageSent = false;
  const flush = (final) => {
    if (visibleSince !== null) {
      engaged += performance.now() - visibleSince;
      visibleSince = null;
    }
    const events = queue.splice(0);
    if (final && !pageSent) {
      pageSent = true;
      measureScroll();
      events.unshift({
        k: 'page',
        t: page.type,
        p: location.pathname,
        l: landing,
        src: landing ? source() : undefined,
        ms: Math.round(engaged),
        sc: maxScroll,
      });
    }
    send(events);
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush(false);
    else visibleSince = performance.now();
  });
  window.addEventListener('pagehide', () => flush(true));

  // ---------- Clicks: menus and guides ----------
  const clean = (el) => {
    const copy = el.cloneNode(true);
    copy.querySelectorAll('svg, img, [class*="meta"], [class*="price"], [class*="count"], [class*="badge"], .visually-hidden').forEach((x) => x.remove());
    return copy.textContent.replace(/\s+/g, ' ').trim().slice(0, 80);
  };
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      let href = '';
      try {
        const u = new URL(link.href, location.href);
        href = u.origin === location.origin ? u.pathname + u.search : u.href;
      } catch (e) {
        return;
      }
      const card = link.closest('.product-item');
      if (card && /\/products\//.test(href) && page.type !== 'product') {
        push({ k: 'card_click', tg: href.replace(/[?#].*$/, '') });
      }
      const item = link.closest('li.level0');
      if (item && link.closest('header, .header, [class*="menu-mobile"], [class*="menu-drawer"], .tl-mobile-nav, nav')) {
        const top = item.querySelector('a');
        const topName = top ? clean(top) : '';
        const name = clean(link);
        push({ k: 'menu_click', lb: top === link ? topName : `${topName} › ${name}`, tg: href });
        return;
      }
      if (/\/blogs\//.test(href) && (page.type === 'product' || page.type === 'parcours' || page.type === 'collection')) {
        push({ k: 'guide_click', lb: clean(link), tg: href });
      }
    },
    true
  );

  // ---------- Search: terms and number of results (search page) ----------
  if (page.type === 'search' && page.terms) {
    push({ k: 'search', lb: String(page.terms).slice(0, 120), v: typeof page.results === 'number' ? page.results : -1 });
  }

  // ---------- Filters on collections (also when applied without reloading) ----------
  const seenFilters = new Set();
  // A filter applied from the quick chips (snippets/terralife-filter-chips.liquid) is tagged « pastille ».
  let chipAt = 0;
  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('[data-tl-chip]')) chipAt = Date.now();
  }, true);
  const readFilters = () => {
    if (page.type !== 'collection' && page.type !== 'search') return;
    const q = new URLSearchParams(location.search);
    q.forEach((value, key) => {
      if (!/^filter\.|^sort_by$/.test(key)) return;
      const label = `${key.replace(/^filter\.(p\.m\.|v\.|p\.)?/, '')}=${value}`.slice(0, 150);
      if (seenFilters.has(label)) return;
      seenFilters.add(label);
      push(Date.now() - chipAt < 8000 ? { k: 'filter', lb: label, tg: 'pastille' } : { k: 'filter', lb: label });
    });
  };
  for (const method of ['pushState', 'replaceState']) {
    const original = history[method];
    history[method] = function (...args) {
      const result = original.apply(this, args);
      setTimeout(readFilters, 0);
      return result;
    };
  }
  window.addEventListener('popstate', readFilters);
  readFilters();

  // ---------- Add to cart (the theme's cart event, from a product page or a card) ----------
  // PUB_SUB_EVENTS is a top-level const of global.js: shared by scripts, not a window property.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'product-form') {
        // The added line (cart/add.js answer) names the product; else the variant id.
        const handle = event.cartData && typeof event.cartData.handle === 'string' ? event.cartData.handle : '';
        const variant = event.productVariantId ? String(event.productVariantId).replace(/\D/g, '') : '';
        push({ k: 'add_to_cart', lb: variant || null, tg: handle ? `/products/${handle}` : page.type === 'product' ? location.pathname : null });
      }
    });
  }

  // ---------- Product cards seen (half visible for 0,6 s), to judge each product's image ----------
  // Collections, search, home and parcours; once per card and page. Cards loaded later
  // (infinite scroll) are picked up too.
  if ('IntersectionObserver' in window && ['collection', 'search', 'home', 'parcours'].includes(page.type)) {
    const seenCards = new Set();
    const timers = new WeakMap();
    const handleOf = (card) => {
      const a = card.querySelector('a[href*="/products/"]');
      const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    };
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          const card = e.target;
          if (e.isIntersecting) {
            timers.set(card, setTimeout(() => {
              const h = handleOf(card);
              if (h && !seenCards.has(h)) {
                seenCards.add(h);
                push({ k: 'card_view', tg: `/products/${h}` });
              }
              io.unobserve(card);
            }, 600));
          } else if (timers.has(card)) {
            clearTimeout(timers.get(card));
            timers.delete(card);
          }
        }
      },
      { threshold: 0.5 }
    );
    const watch = (root) => root.querySelectorAll('.product-item').forEach((c) => {
      if (!c.dataset.tlSeen) {
        c.dataset.tlSeen = '1';
        io.observe(c);
      }
    });
    watch(document);
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      setTimeout(() => {
        pending = false;
        watch(document);
      }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ---------- Wishlist adds (assets/terralife-wishlist-events.js) ----------
  document.addEventListener('tl:wishlist-add', (event) => {
    const handle = event.detail && event.detail.handle;
    push({ k: 'wishlist_add', lb: handle || null, tg: handle ? `/products/${handle}` : null });
  });

  // ---------- Product page: tank label option, description really seen ----------
  document.addEventListener('change', (event) => {
    if (event.target.matches && event.target.matches('[data-tl-label-check]')) {
      push({ k: 'label_option', v: event.target.checked ? 1 : 0 });
    }
  });
  const description = page.type === 'product' && document.querySelector('.tlpd');
  if (description && 'IntersectionObserver' in window) {
    let timer = null;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          timer = setTimeout(() => {
            push({ k: 'description_seen' });
            observer.disconnect();
          }, 2000);
        } else if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(description);
  }
})();
